import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { listenTo, clearBindings, clone } from '../util/Utility.js';
import { CCOButtonGroup, CCOButton, CCOAlert } from '../util/Components';
import { ControlLabel, FormGroup, Radio } from 'react-bootstrap';
import CollectionEditView from './CollectionEditView';
import { ScaleLoader } from 'react-spinners';

export default class SermonView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      book: null,
      sections: [],
      width: window.innerWidth,
      type: 0,
      collections: clone(window.sermon_collections),
      updateSermonsResponse: null,
      udpateSermonsLoading: false
    }
  }

  componentDidMount() {
    // this.remove = window.base.syncState('sermon_collections', {
    //   context: this,
    //   state: 'collections',
    //   asArray: 'true'
    // });

    this.resetSections();
  }

  componentWillUnmount() {
    clearBindings()
    //window.base.removeBinding(this.remove);
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  fetchObjects(limit, callback) {
    if (this.state.collection === "N/A") {
      listenTo("sermons", this, sermons => {
        callback(sermons.filter(item => item.collection === undefined))
      }, {
        orderByChild: 'collection'
      })
    } else if (this.state.type === 1 && this.state.collection) {
      listenTo("sermons", this, sermons => callback(sermons), {
        orderByChild: 'collection',
        limitToLast: limit,
        equalTo: this.state.collection
      })
    } else {
      listenTo("sermons", this, sermons => callback(sermons), {
        orderByChild: 'date',
        limitToLast: limit
      })
    }
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  resetSections() {
    this.setState({sections: Object.keys(this.state.collections).map(item => { return {title: this.state.collections[item].name, filter: e => e.collection === item}})});
  }

  updateSermons(range) {
    this.setState({updateSermonsLoading: true, updateSermonsResponse: null}, () => {
      fetch('https://us-central1-ccoapp.cloudfunctions.net/updateSermons?range=' + range).then(response => {
        return response.json()
      }).then(json => {
        this.setState({updateSermonsResponse: json, updateSermonsLoading: false})
      }).catch(ex => {
        console.warn(ex)
        this.setState({updateSermonsResponse: {status: "failed", error: JSON.stringify(ex)}, updateSermonsLoading: false})
      })
    })
  }

  render() {

    var options = Object.keys(this.state.collections).map(key => {
      return <Radio key={key} checked={this.state.collection === key} onChange={() => this.setState({collection: key})}>{this.state.collections[key].name}</Radio>
    });

    let sections = this.state.sections;
    if (this.state.collection) {
      if (this.state.collection === "N/A") {
        sections = [{title: "Uncollected Sermons", filter: e => e.collection === undefined}];
      } else {
        sections = [{title: this.state.collections[this.state.collection].name, filter: e => e.collection === this.state.collection}];
      }
    }

    let updateSermonAlert = {};
    if (this.state.updateSermonsResponse) {
      let usr = this.state.updateSermonsResponse;
      if (usr.status === "failed") {
        updateSermonAlert = {
          header: "Error Running Script",
          text: usr.error,
          type: 'danger'
        }
      } else {
        if (usr.status === "warnings") {
          updateSermonAlert = {
            header: "Completed with Warnings",
            text: "Warnings:\n" + usr.warn + "\n\nOutput:\n" + usr.info,
            type: 'warning'
          }
        } else {
          updateSermonAlert = {
            header: "Completed Successfully",
            text: usr.info,
            type: 'success'
          }
        }
      }
    }

    return (
      <div>
        <center style={{paddingHorizontal: 20}}><CCOButton text="Manage Collections" onClick={() => this.setState({manageCollections: true})} type="primary" maxWidth={500} /></center>
        <div style={{height: 10}} />
        <center style={{paddingHorizontal: 20, marginBottom: 15}}>
          <h4>Run Update Script</h4>
          {this.state.updateSermonsLoading
            ? <div style={{height: 40, paddingTop: 5}}><ScaleLoader loading height={25} width={5} color="#0076FF" /></div>
            : <div>
              <CCOButton style={{marginRight: 5}} text="Last Week Only" onClick={() => this.updateSermons("week")} type="primary" maxWidth={245} />
              <CCOButton style={{marginLeft: 5}} text="All on Current Page" onClick={() => this.updateSermons("page")} type="primary" maxWidth={245} />
            </div>}
          <div style={{height: 5}} />
          <div style={{maxWidth: 500}}><CCOAlert in={this.state.updateSermonsResponse !== null} type={updateSermonAlert.type} title={updateSermonAlert.header} content={updateSermonAlert.text} /></div>
        </center>
        <div style={{height: 10}} />
        <center style={{paddingHorizontal: 20}}><CCOButtonGroup onClick={type => {this.setState({type})}} items={["Order by Date", "Order by Collection"]} width={500} /></center>
        <div style={{height: 20}} />
        {this.state.width > 444 && this.state.type === 1 &&
        <div className="sidePanel">
          <ControlLabel>Filter by Collection</ControlLabel>
          <FormGroup>
            <Radio checked={this.state.collection === null} onChange={() => this.setState({collection: null})}>All</Radio>
            {options}
            <Radio key={"N/A"} checked={this.state.collection === "N/A"} onChange={() => this.setState({collection: "N/A"})}>Uncollected</Radio>
          </FormGroup>
        </div>
        }
        <PanelHolder addable side={this.state.width > 444 && this.state.type === 1 && window.innerWidth < 850} sortFunc={this.state.type === 1 ? (a, b) => a.mainVerse && b.mainVerse && a.mainVerse.startChapter - b.mainVerse.startChapter : (a, b) => { return b.date - a.date }} fetch={this.state.collection} sections={this.state.type === 1 ? sections : null} type="sermon" fetchObjects={this.fetchObjects.bind(this)} {...this.props} />

        <CollectionEditView show={this.state.manageCollections} done={collections => this.setState(Object.assign({manageCollections: false}, collections ? {collections} : null), () => this.resetSections())} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/sermons/SermonView.js
 **/